<template>
  <div class="fh-form-content fh-form-content-com">
    <slot name="header">
      <div class="form-title">
        <div class="form-operation-view">
          <jw-button class="operation-icon" size="small" @click="changeScreenWidth(!isFullScreen)">
            <template #icon>
              <qfei-icon-full-screen-outlined v-if="!isFullScreen" />
              <qfei-icon-contract-outlined v-else />
            </template>
          </jw-button>
          <jw-tag :class="['formTag', formType == '30' ? 'add-tag' : 'edit-tag']">{{ formType == '30' ? '新建' : '编辑' }}</jw-tag>
          <div class="form-main-field">{{ objectName }}</div>
          <slot name="view"></slot>
        </div>
        <div class="form-btns">
          <!-- 提交 -->
          <jw-button size="small" type="primary" v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']" :loading="loading" :disabled="data.submitDisabled" @click="submit">
            <template #icon v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.icon && (buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.showType == 0 || buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.showType == 1)">
              <component :is="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.icon" />
            </template>
            <template v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.showType == 0 || buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.showType == 2">
              {{ buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.title }}
            </template>
            <template v-else>
              {{ buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':commit']?.title }}
            </template>
          </jw-button>
          <!-- 提交并发起审批 -->
          <jw-button size="small" v-if="showApproveBtn && statusOrigin !== 2" type="primary" :disabled="data.submitDisabled" :loading="loading" @click="submit('approve')">
            <jw-space>
              <span>保存并发起审批</span>
              <jw-tooltip :popup-translate="[-100, 10]">
                <icon-question-circle-fill />
                <template #content>
                  <p>1.保存提交并发起审批时，会直接发起审批</p>
                  <p>2.选择保存时，不会发起审批，可在完善信息后，再发起审批</p>
                </template>
              </jw-tooltip>
            </jw-space>
          </jw-button>
          <!--提交并按明细拆分(销售订单的)  -->
          <template v-if="entity == 10 && buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']">
            <jw-button size="small" type="primary" v-if="buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']" :disabled="data.submitDisabled" :loading="loading" @click="splitOrderSubmit">
              <template #icon v-if="buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit'].icon && (buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.showType == 0 || buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.showType == 1)">
                <component :is="buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.icon" />
              </template>
              <template v-if="buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.showType == 0 || buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.showType == 2">
                {{ buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.title }}
              </template>
              <template v-else>
                {{ buttonsObj?.[`${objectRoleEnum[entity]}` + ':commitAndSplit']?.title }}
              </template>
            </jw-button>
            <jw-tooltip position="lt">
              <template #content> {{ $t('tips.saveOrder') }} </template>
              <icon-question-circle size="20" />
            </jw-tooltip>
          </template>
          <!-- 取消 -->
          <jw-button size="small" type="outline" v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']" @click="cancelForm">
            <template #icon v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.icon && (buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.showType == 0 || buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.showType == 1)">
              <component :is="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.icon" />
            </template>
            <template v-if="buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.showType == 0 || buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.showType == 2">
              {{ buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.title }}
            </template>
            <template v-else>
              {{ buttonsObj?.[`${entity >= 200 ? entity : objectRoleEnum[entity]}` + ':cancel']?.title }}
            </template>
          </jw-button>
          <div class="form-btn-right">
            <div class="line" />
            <jw-button size="small" class="operation-icon" @click="cancelForm">
              <template #icon>
                <qfei-icon-close-one-outlined />
              </template>
            </jw-button>
          </div>
        </div>
      </div>
    </slot>
    <div class="fh-form-content">
      <div class="fh-form-skeleton" v-if="!showContent">
        <jw-skeleton animation>
          <div class="fh-form-skeleton-box">
            <div class="fh-form-skeleton-item fh-form-skeleton-item-one-line">
              <jw-skeleton-line />
            </div>
            <template v-for="i in 20" :key="i">
              <div class="fh-form-skeleton-item">
                <div class="fh-form-skeleton-item-label"><jw-skeleton-line /></div>
                <div class="fh-form-skeleton-item-input"><jw-skeleton-line /></div>
              </div>
            </template>
          </div>
        </jw-skeleton>
      </div>
      <slot name="formTop" :isInit="showContent" />
      <template v-if="data.form.formData?.length > 0 && showContent">
        <slot name="form" :layout="formLayout">
          <jw-form :model="data.form" label-align="left" :layout="formLayout" class="form-min-width" ref="editAddForm" @submit="handleSubmit" scroll-to-first-error>
            <template v-for="(item, parentIndex) in data.form.formData" :key="item.id">
              <template v-if="item?.modules?.length > 0 && validateConditionsDisplay(item)?.length > 0">
                <div class="split-line" v-if="parentIndex !== 0" />
                <div class="group-title" v-if="isShowGroupName(item?.modules)" :class="{ collapsed: item.collapsed }" @click="item.collapsed = !item.collapsed">
                  <div class="prefix-icons">
                    <qfei-icon-caret-down-outlined v-show="!item.collapsed" class="prefix-icon" />
                    <qfei-icon-caret-right-outlined v-show="item.collapsed" class="prefix-icon" />
                  </div>
                  <div class="group-name">{{ item?.label || '分组' }}</div>
                  <jw-tooltip v-if="item?.toast">
                    <icon-question-circle size="14" class="card-tooltip" />
                    <!-- 这是提示文本  -->
                    <template #content>{{ item.toast }}</template>
                  </jw-tooltip>
                </div>
                <template v-if="isShowGroupName(item?.modules)">
                  <div v-show="!item.collapsed" class="fields-wrapper">
                    <template v-for="(modulesItem, index) in item?.modules" :key="modulesItem.id">
                      <template v-if="((modulesItem?.conditionsDisplay == 1 && modulesItem.display == 2) || modulesItem.display == 1) && (modulesItem.type == '20' ? getFollowIsHide(modulesItem) : true)">
                        <!--  0是1/2行展示，1是整行 2是1/3  3是2/3行展示 -->
                        <div
                          :class="['field-item', modulesItem.type == '20' && modulesItem.value == getEntityObj?.associateKey ? 'field-item-display' : '']"
                          :style="{
                            '--span': getRecordType(modulesItem.type) || modulesItem.type == '35' || (modulesItem.type == '20' && (data.displayOneLineFields.includes(modulesItem?.setting?.fieldType) || modulesItem.displayOneLine == 1)) ? 6 : modulesItem.type == '20' && modulesItem.displayOneLine == 0 ? 3 : modulesItem.type == '20' && modulesItem.displayOneLine == 3 ? 4 : modulesItem.type == '20' && modulesItem.displayOneLine == 2 ? 2 : 3
                          }"
                        >
                          <!-- 字段 -->
                          <template v-if="modulesItem.type == '20'">
                            <!-- 类名`system-form-item-${modulesItem?.setting?.id}`勿删：此处为兼容下拉等弹窗popup-container的定位问题 -->
                            <jw-form-item
                              asterisk-position="end"
                              :field="`formData.${parentIndex}.modules.${index}.fieldValue`"
                              :class="['system-form-item', `system-form-item-${modulesItem?.setting?.id}`, modulesItem?.setting?.fieldType === 12 ? 'relevancy-input' : '', data.checks?.includes(modulesItem?.setting?.fieldType) ? 'checked-list' : '', getDisplayOneLine(item, modulesItem, index)]"
                              :rules="modulesItem.value === 'mobile' && entity == 2 ? mobileRules(modulesItem) : rules(modulesItem)"
                              :validate-trigger="['blur', 'input', 'change']"
                              :label-col-style="{
                                width: labelWidth(modulesItem)
                              }"
                              label-col-flex="auto"
                              class="form-label-text"
                            >
                              <template #label>
                                <component :is="fieldIconMapping[modulesItem.setting?.fieldType]" style="margin-right: 8px" />
                                <xl-label-text :value="modulesItem.label" :row="1" />
                                <jw-tooltip v-if="modulesItem?.toast">
                                  <icon-question-circle size="18" />
                                  <!-- 这是提示文本  -->
                                  <template #content>
                                    {{ modulesItem.toast }}
                                  </template>
                                </jw-tooltip>
                              </template>
                              <!-- 线索和线索池对象公司名称判重 -->
                              <template v-if="(entity == 1 || entity == 101) && modulesItem.value === 'companyName'">
                                <jw-input v-qfeiTrim v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-fields" @press-enter="companyInput(modulesItem)" @blur="companyInput(modulesItem)" />
                                <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                              </template>
                              <!-- 客户对象特殊处理 -->
                              <!-- 客户名称 -->
                              <template v-else-if="entity == 2 && modulesItem.value === 'customerName'">
                                <div class="customer-name-list">
                                  <div class="customer-name-item">
                                    <jw-input v-qfeiTrim v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-fields" @input="customerInput(modulesItem)">
                                      <template #suffix>
                                        <jw-tooltip v-if="data.qccId" :content="$t('查看工商信息')" position="br" mini>
                                          <span @click.stop="businessShow" style="display: flex; align-items: center">
                                            <qf-icon-business class="icon-qcc" width="20px" height="20px" color="rgb(var(--primary-6))" />
                                          </span>
                                        </jw-tooltip>
                                        <qf-icon-business class="icon-qcc disabled" v-else width="20px" height="20px" color="#C9CDD4" />
                                      </template>
                                    </jw-input>
                                  </div>
                                  <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                                </div>
                              </template>
                              <!-- 关联工商信息 -->
                              <template v-else-if="entity == 2 && modulesItem.value === 'qccId'">
                                <div style="display: flex; flex-direction: column">
                                  <jw-button @click="correlation" :disabled="modulesItem.businessData == '0' || data.disabledAll" size="small" type="primary">{{ $t('关联工商信息') }}</jw-button>
                                  <span v-if="!data.qccId && (modulesItem.isRequired == 1 || modulesItem?.conditionsIsRequired == 1)" style="color: rgb(var(--danger-6)); font-size: 12px">{{ $t('tips.customerIsRequired') }}</span>
                                </div>
                              </template>
                              <!-- 商机对象特殊处理 -->
                              <!-- 商机名称校验-->
                              <template v-else-if="entity == 3 && modulesItem.value === 'opportunityName'">
                                <jw-input v-qfeiTrim v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-value" @press-enter="changeOpportunityName(modulesItem)" @blur="changeOpportunityName(modulesItem)" />
                                <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                              </template>
                              <template v-else-if="entity == 3 && modulesItem.value === 'association_b6DERm'">
                                <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll" @change="fundChange" />
                              </template>
                              <!-- 合同/订单中的报价单 -->
                              <template v-else-if="(entity == 8 || entity == 10) && modulesItem.value === 'priceSheetId'">
                                <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll" @change="priceChange(6)" />
                              </template>

                              <!-- 订单中的合同 -->
                              <template v-else-if="entity == 10 && modulesItem.value === 'contractId'">
                                <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll" @change="contractChange(8)" />
                              </template>
                              <template v-else>
                                <fh-update-fields :modules="modulesItem" :type="type" :entity="entity" :disabled-all="data.disabledAll" :formatData="data.form.formData" @cb="(getFormatData, moduleItem) => updateModulesItem(parentIndex, index, getFormatData, moduleItem)" :errorDataMap="data.errorDataMap" />
                              </template>
                              <!--附加说明 -->
                              <div class="tips-detail" v-if="modulesItem?.memo">
                                {{ modulesItem?.memo }}
                              </div>
                            </jw-form-item>
                          </template>
                          <!-- 查询记录 (31)，关联记录（30）-->
                          <template v-else-if="getRecordType(modulesItem.type)">
                            <jw-form-item
                              v-if="showRecordTable(modulesItem)"
                              asterisk-position="end"
                              :field="`formData.${parentIndex}.modules.${index}.fieldValue`"
                              :class="['system-form-item', `system-form-item-${modulesItem?.setting?.id}`, modulesItem?.setting?.fieldType === 12 ? 'relevancy-input' : '', data.checks?.includes(modulesItem?.setting?.fieldType) ? 'checked-list' : '', 'table-item']"
                              :label-col-style="{
                                width: labelWidth(modulesItem)
                              }"
                              hide-label
                              label-col-flex="auto"
                              class="form-label-text"
                            >
                              <!-- 关联记录，查询记录 -->
                              <fh-form-table
                                :formType="formType"
                                :findCountFieldsList="findCountFieldsObj?.[modulesItem?.businessData] || []"
                                :detailDataList="detailModuleList?.[modulesItem?.id]"
                                :type="type"
                                :copy="copy"
                                :viewId="data.viewId"
                                :entity="entity"
                                :id="data.id"
                                :formData="data.form.formData"
                                @updateDataList="updateDataList"
                                :modulesItem="{
                                  ...modulesItem,
                                  modules: modulesItem.modules?.filter((v) => v.value != modulesItem?.associateKey && v.type != 40)
                                }"
                                :btns="isEditableField([modulesItem?.value, modulesItem?.id], permission.value, data.permissionBak?.[modulesItem.value]?.businessData ?? 1) && !data.disabledAll ? tableModuleBtnList?.[modulesItem?.id] ?? [] : []"
                                :formLayout="formLayout"
                              />
                            </jw-form-item>
                          </template>
                          <!-- 子表单 (35)-->
                          <template v-else-if="modulesItem.type == '35'">
                            <jw-form-item
                              asterisk-position="end"
                              :field="`formData.${parentIndex}.modules.${index}.fieldValue`"
                              :class="['system-form-item', `system-form-item-${modulesItem?.setting?.id}`, modulesItem?.setting?.fieldType === 12 ? 'relevancy-input' : '', data.checks?.includes(modulesItem?.setting?.fieldType) ? 'checked-list' : '', 'table-item']"
                              :label-col-style="{
                                width: labelWidth(modulesItem)
                              }"
                              hide-label
                              label-col-flex="auto"
                              class="form-label-text"
                            >
                              <fh-form-subform @updateDataList="updateDataList" :modulesItem="modulesItem" :dataList="detailModuleList?.[modulesItem?.id]" :type="type" :copy="copy" :viewId="viewId" :entity="entity" :id="id" :isAssociated="isAssociated" :disabledAll="data.disabledAll" :permission="permission" :permissionBak="data.permissionBak" :from="20" :mainForm="data.form.formData" />
                            </jw-form-item>
                          </template>
                        </div>
                      </template>
                    </template>
                  </div>
                </template>
              </template>
            </template>
          </jw-form>
        </slot>
      </template>
      <template v-else-if="showContent">
        <jw-empty :img-src="noDataSvg" :description="$t('暂无数据')" />
      </template>
    </div>
  </div>
  <!-- 关联工商信息 -->
  <xl-business-information ref="informationRef" @cb="getSelectCustomer"></xl-business-information>
  <!-- 展示关联的工商信息 -->
  <xl-business-message ref="businessMessageRef"></xl-business-message>
</template>

<script setup>
import { ref, reactive, inject, computed } from 'vue';
import { cloneDeep } from 'lodash';
import FhFormTable from '../fh-form-table/fh-form-table.vue';
import FhFormSubform from '../fh-form-subform/fh-form-subform.vue';
import noDataSvg from '@/assets/images/no-data-150.svg';
import useViewFields from '@/hooks/view-fields';
import fieldPermission from '@/hooks/field-permission';
import FhUpdateFields from '../fh-update-fields/fh-update-fields.vue';
import fieldDefaultVal from '@/hooks/default-value';
import { useFormWatch } from '@/hooks/form-watch';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';
import { useUserStore, useFormTableStore } from '@/store';
import { useEnvConfig } from '@/hooks/env-config';
import { migrationToolsService } from '@/api';
import useFhForm from '@/hooks/fh-form';
import dayjs from 'dayjs';
import { bingOrgId, huaYingOrdId, objectRoleEnum } from '@/utils/const';
import { clientService, setService } from '@/api/';
import useFormConfig from '@/hooks/form-config';
import { QfeiIconCloseOneOutlined, QfeiIconFullScreenOutlined, QfeiIconContractOutlined, QfeiIconCaretRightOutlined, QfeiIconCaretDownOutlined } from '@qfei-design/icons-vue';
import useFields from '@/hooks/fields';
const detailAllFields = inject('detailParams')?.detailAllFields;
const { isEditableField, initPermissionBak, isRequiredField } = fieldPermission();
const { getNewDefVal, updateSubFormKeys } = fieldDefaultVal();
const { t } = useI18n();
const { rules, setEditFormTable } = useViewFields();
import useObjectForm from '@/hooks/object-form';
// import useLoading from '@/hooks/loading';
// const { loading, setLoading } = useLoading(true); //loading
const { getRecordType } = useObjectForm();
const { isEmptyFieldValue } = useFhForm();
const props = defineProps({
  // 表单按钮信息
  buttonsObj: {
    type: Object,
    default: () => {}
  },
  // 计算字段合集
  findCountFieldsObj: {
    type: Object,
    default: () => {}
  },
  //页面类型 30新建 40编辑
  type: {
    type: [Number, String],
    default: ''
  },
  //是否是复制 0否 1是
  copy: {
    type: [Number, String],
    default: 0
  },
  viewId: {
    type: [Number, String],
    default: ''
  },
  entity: {
    type: [Number, String],
    default: ''
  },
  id: {
    type: [Number, String],
    default: ''
  },
  //是否是关联对象表格新建编辑
  isAssociated: {
    type: Boolean,
    default: false
  },
  associateKey: {
    type: String,
    default: ''
  },
  editRecord: {
    type: Array,
    default: () => []
  },
  form: {
    type: Object,
    default: () => ({ formData: [], config: {} })
  },
  scheduleObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  loading: {
    type: Boolean,
    default: false
  },
  followObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  getEntityObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  modulesItem: {
    //关联记录，查找记录的module信息
    type: Object,
    default: () => {
      return {};
    }
  }
});
const emits = defineEmits('cb');
const { fieldIconMapping } = useFields();
const { userInfo } = useUserStore(); //用户信息
const formTableStore = useFormTableStore();
const { fieldMappings, config } = useEnvConfig(props.entity);
const isInit = ref(false);
const isFormPermissionInit = ref(false);
const changeAutoWidth = ref(inject('formMethod')?.changeAutoWidth);
const isFullScreen = ref(false);
const formType = ref(props.type); // 表单状态 30 新建 40 编辑
const changeScreenWidth = (v) => {
  console.log('changeScreenWidth', v);
  changeAutoWidth.value(v);
  isFullScreen.value = v;
};
const updateDataList = (dl) => {
  detailModuleList.value[dl?.id] = dl?.data;
};
const objectName = ref(''); // 对象名称
const getObjectName = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: props.entity });
    if (!res.error) {
      objectName.value = res.result?.entityName;
    }
  } catch (e) {
    console.log(e);
  }
};

const formLayout = computed(() => {
  return (
    {
      0: 'horizontal',
      1: 'vertical'
    }[props.form?.config?.formLayout] || 'horizontal'
  );
});
const data = reactive({
  id: props?.id || '',
  displayOneLineFields: [18, 26], //整行显示的字段
  permissionBak: {}, // 业务规则
  errorDataMap: {}, // 计算字段错误信息
  disabledAll: false,
  qccId: null,
  qccInfo: null,
  form: {
    formData: []
  },
  checks: [2, 3, 4, 5],
  isApproveSave: false,
  isSplit: false,
  submitDisabled: false
});
const showContent = computed(() => {
  return isFormPermissionInit.value && isInit.value;
});
// 是否显示记录表格
const showRecordTable = (item) => {
  if (!props.isAssociated) return true;
  if (props.isAssociated) {
    //表格来源
    if (props.modulesItem?.type == 31) return true;
    if (props.modulesItem?.type == 30) return item?.type == 31;
  }
};
const { showApproveBtn, statusOrigin, defaultFields, initFormConfig } = useFormConfig(props.entity, props.id, props.type, props.isAssociated);
const detailModuleList = ref({});
const tableModuleBtnList = ref({});
const informationRef = ref(); //客户--关联工商信息
const businessMessageRef = ref(); //客户--展示工商信息
const checkName = ref(); //公司名称/客户名称/商机名称校验重复
const permission = ref();

const labelWidth = (callbackData) => {
  if (formLayout.value === 'vertical') {
    return '100%';
  }
  let width = '155px'; //1/2
  if (callbackData.displayOneLine == 2) {
    width = '180px'; //2是1/3
  } else if (callbackData.displayOneLine == 3) {
    width = '146px'; //3是2/3行展示
  } else if (callbackData.displayOneLine == 1) {
    width = '128px'; //整行
  }
  if (data.displayOneLineFields.includes(callbackData?.setting?.fieldType) || [30, 31].includes(+callbackData?.type)) {
    width = '128px'; //附件,富文本,关联记录，查询记录
  }
  return width;
};
const getDisplayOneLine = (item, modulesItem, index) => {
  if (data.displayOneLineFields?.includes(modulesItem?.setting?.fieldType) && (item?.modules?.[index - 1]?.displayOneLine != 1 || item?.modules?.[index + 1]?.displayOneLine != 1)) {
    return 'display-one-line-field';
  }
  return '';
};
const setDetailProduct = (id, entity) => {
  if (!detailModuleList.value?.[id]?.length) return;
  const dl = cloneDeep(detailModuleList.value?.[id]);
  const _newData = [];
  dl?.forEach((df) => {
    if (df?.[0]?.detailEntityId != entity) {
      _newData.push(df);
    }
  });
};

// 合同/订单中切换报价单
const priceChange = (entity) => {
  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 30 && item?.modules) {
          //组件表格
          setDetailProduct(item?.id, entity); //需要把有关带出的明细清除
        }
      });
    }
  });
};
//订单中切换合同
const contractChange = (entity) => {
  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 30 && item?.modules) {
          //组件表格
          setDetailProduct(item?.id, entity); //需要把有关带出的明细清除
        }
      });
    }
  });
};
// 检测引用字段

const referenceFields = (formData) => {
  const _formData = cloneDeep(formData);
  const _referenceFields = [];
  _formData.forEach((_fd) => {
    if (_fd?.modules?.length) {
      _fd?.modules?.forEach((_fdm) => {
        if (_fdm.type == 20 && _fdm?.setting?.fieldType == 21) {
          _referenceFields.push(_fdm?.setting?.fieldKey);
        }
      });
    }
  });
  return _referenceFields;
};

/**
 * 处理关联字段数据（仅针对新增场景：从其他对象详情关联记录(30)新增）
 * 场景条件：type=30 且 非复制状态（copy!==1）
 */
const setAssociatedFeildData = ref({});
const handleAssociatedFieldData = () => {
  if (props?.type == 30 && props?.copy != 1 && props.getEntityObj?.associateKey) {
    const { associateKey, value } = props.getEntityObj;
    const formDataList = data.form.formData || [];
    let associatedField = null;
    formDataList?.some((formItem) => {
      const modules = formItem?.modules || [];

      associatedField = modules.find((module) => module?.type == 20 && module?.value == associateKey);
      // 找到后终止循环
      return !!associatedField;
    });
    // 未找到关联主键时，存储关联数据（给后端使用）
    if (!associatedField) {
      setAssociatedFeildData.value[associateKey] = value;
    }
  }
};

const formatFormData = async () => {
  const _formData = cloneDeep(props.form.formData);
  if (props.type == 30 && !props.editRecord?.length && props.copy != 1) {
    const defaultValueParams = {
      entity: props.entity,
      formData: _formData,
      init: true
    };
    await getNewDefVal(defaultValueParams, 1);
  }
  //获取placeholder
  const getPlaceholder = (m) => {
    let placeholder = t('请选择');
    if ([0, 1, 7, 11, 13, 16, 21, 23, 26].includes(m?.setting?.fieldType)) {
      placeholder = t('请输入');
    }

    return placeholder;
  };

  _formData.forEach((_fd) => {
    _fd.collapsed = false;
    if (_fd?.modules?.length) {
      /*********** 关联表格过滤关联主键 start ************/

      if (props.isAssociated && props.associateKey) {
        _fd.modules = _fd?.modules?.filter((_fdm) => _fdm?.setting?.fieldKey != props.associateKey);
      }
      /*********** 关联表格过滤关联主键 end ************/
      _fd?.modules?.forEach((_fdm) => {
        // 老数据取字段单独的布局配置 新数据取统一的布局配置
        _fdm.displayOneLine ??= props.form?.config?.displayOneLine;
        //商机阶段默认值
        if (props.entity == 3 && props.type == 30 && props.copy != 1 && _fdm.value == 'opportunityStage') {
          const _fieldExt = JSON.parse(_fdm.setting.fieldExt);
          _fdm.fieldValue = _fieldExt[0].value;
        }
        //跟进记录特殊处理
        if (props.followObj?.isSourceDetailStatus) {
          if (_fdm?.setting?.fieldKey == 'entityType') {
            _fdm.fieldValue = props.followObj.sourceEntity.toString();
          }
          if (_fdm?.setting?.fieldKey == 'businessId') {
            _fdm.fieldValue = props.followObj.sourceId.toString();
          }
          if (_fdm?.setting?.fieldKey == 'followStartTime' && _fdm.isExistDefValue == 0 && props.scheduleObj.followStartTime) {
            _fdm.fieldValue = props.scheduleObj.followStartTime;
          }
        }
        //是关联对象表格过来的，并且没有id，并且编辑数据不为空，则将子表单数据同步到表格中
        if (props.isAssociated && !data.id && props.editRecord?.length) {
          if (_fdm.type == 35 && _fdm?.modules?.length) {
            const _find = props.editRecord?.find((v) => v?.setting?.fieldKey === _fdm?.setting?.fieldKey);
            if (_find && Object.keys(_find)?.length) {
              const _formatSubFormData = [];
              _find?.modules?.map((fm) => {
                const _child = {};
                fm?.map((fmm) => {
                  _child[fmm?.value] = fmm?.fieldValue;
                });
                _formatSubFormData.push(_child);
              });
              _fdm.fieldValue = {
                records: _formatSubFormData
              };
            }
          }
        }
        //普通字段特殊处理
        if (_fdm.type == 20) {
          //客户--关联工商信息
          if (_fdm?.setting.fieldKey == 'qccId') {
            data.qccId = _fdm.fieldValue;
          }
          if (props.type == 30 && props.copy !== 1) {
            //新增的时候处理（从其他对象详情关联对象表格新增）
            if (props.getEntityObj && Object.keys(props.getEntityObj)?.length > 0) {
              if (_fdm?.setting.fieldType == 12 && _fdm?.setting.fieldExt == props.getEntityObj.fieldExt) {
                //查找关联单选
                _fdm.fieldValueName = detailAllFields.value?.[_fdm?.setting?.outShowField] ?? props.getEntityObj.label;
                _fdm.fieldValue = props.getEntityObj.value;
              }
            }
          }
          //将关联对象表格数据与表单数据进行合并 场景：关联对象表格编辑数据，未落库，再次点击编辑不能重新获取接口数据，需要读取用户上次修改过的数据
          if (props.editRecord?.length) {
            const _find = props.editRecord?.find((v) => v?.setting?.fieldKey === _fdm?.setting?.fieldKey);
            if (_find && Object.keys(_find)?.length) {
              _fdm.fieldValue = _find.fieldValue;
              _fdm.setting = cloneDeep(_find.setting);
              if ([12, 25].includes(_fdm.setting.fieldType)) {
                _fdm.customValue = cloneDeep(_find.customValue);
                if (_find?.fieldValueName) {
                  _fdm.fieldValueName = _find.fieldValueName;
                }
              }
            }
          }
          //产品--税率字段(因为fieldType==4 需要特殊处理label: "0.06"处理成'6%')
          if (props.entity == 4 && _fdm?.setting?.fieldKey === 'taxRate' && _fdm?.setting?.fieldType == 4 && tools.isJSON(_fdm.setting?.fieldExt)) {
            const fe = JSON.parse(_fdm.setting?.fieldExt)?.map((v) => ({
              ...v,
              label: tools.getPercentage(v.label, 0) + '%'
            }));
            _fdm.setting.fieldExt = JSON.stringify(fe);
          }
        }

        if (props.type == 30 && props.copy != 1 && !props.editRecord?.length) {
          //新增---子表单
          const getSubFormKeys = Object.keys(updateSubFormKeys.value);
          if (getSubFormKeys?.length > 0) {
            if (_fdm.type == 35 && _fdm?.modules?.length && getSubFormKeys.includes(_fdm.setting.fieldKey)) {
              const getRecord = updateSubFormKeys.value[_fdm.setting.fieldKey];
              if (getRecord?.length) {
                detailModuleList.value[_fdm.id] = setEditFormTable(_fdm?.modules, getRecord);
              }
            }
          }
        }
        //查询记录，关联记录字段数据处理
        if (getRecordType(_fdm?.type) && _fdm?.modules) {
          tableModuleBtnList.value[_fdm.id] = _fdm?.modules?.filter((v) => v.type == 40) || [];
          _fdm?.modules?.forEach((_fdmm) => {
            _fdmm.businessData = null;
            _fdmm.placeholder = getPlaceholder(_fdmm);
            if (_fdmm?.type == 35) {
              _fdmm?.modules?.forEach((_fdmmm) => {
                _fdmmm.businessData = null;
                _fdmmm.placeholder = getPlaceholder(_fdmmm);
              });
            }
          });
        }
        if (getRecordType(_fdm?.type) && _fdm?.modules) {
          //将数据存储在store中 新建也需要存储为空，不然用户新建页面可能读取到旧的数据
          // formTableStore.setTableData(_fdm.id, setEditFormTable(_fdm?.modules, _fdm?.fieldValue?.records) || []);
          if (props.type == 40 || props.copy == 1 || _fdm?.type == 31) {
            detailModuleList.value[_fdm.id] = _fdm?.fieldValue ? setEditFormTable(_fdm?.modules, _fdm?.fieldValue?.records) : [];
          }
        }
        //做单数据流，子表单信息在初始化时格式化并传参到子表单组件
        if (_fdm?.type == 35 && _fdm?.modules && _fdm?.fieldValue?.records?.length) {
          detailModuleList.value[_fdm.id] = _fdm?.fieldValue?.records ? setEditFormTable(_fdm?.modules, _fdm?.fieldValue?.records) : [];
        }
        if (_fdm.type == 35) {
          console.log('_fdmelement-sub', _fdm);
        }

        if (_fdm?.setting?.fieldType == 4 && _fdm?.value == 'entityType' && _fdm?.fieldValue) {
          _fdm.fieldValue = _fdm.fieldValue.toString();
        }
      });
    }
  });

  data.form.formData = _formData;
  handleAssociatedFieldData();
};
const initForm = async () => {
  const permissionBak = initPermissionBak(props.form.formData, props.type);
  data.permissionBak = permissionBak;
  await formatFormData();
  // setLoading(false);

  const op = {
    viewId: props.viewId,
    entity: props.entity,
    formData: data.form.formData,
    detailList: props.detailModuleList,
    type: props.type,
    id: props.id || null,
    from: 1,
    permissionBak,
    init: true
  };

  const currentComputedFieldsList = props.findCountFieldsObj?.[props.entity] || []; // 当前对象计算字段合集
  const referenceFieldsList = referenceFields(data.form.formData);
  const { errorDataMap, fieldPermission, isDisabledAll } = useFormWatch(data.form.formData, props.entity, op, props.copy === 1, currentComputedFieldsList, referenceFieldsList, () => (isFormPermissionInit.value = true), defaultFields, getDefaultValues);
  data.disabledAll = isDisabledAll;
  data.errorDataMap = errorDataMap;
  permission.value = fieldPermission;
  //初始化公共信息
  initFormConfig();
  isInit.value = true;
  getObjectName();
};
const mobileRules = (basic) => {
  if (basic.isRequired == 1 || basic?.conditionsIsRequired == 1) {
    // 0-非必填 1-必填 2-满足条件必填
    return [
      {
        required: basic.isRequired,
        message: t('tips.phoneNumber')
      }
    ];
  }
};
// 所有字段或者分组隐藏了需要把分组标题隐藏掉
const validateConditionsDisplay = (moduleItem) => {
  const isDisplayField = [];
  moduleItem.modules?.forEach((module) => {
    if (module.type == 20) {
      //字段
      if ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1) {
        isDisplayField.push(module);
      }
    }
    if ((getRecordType(module.type) || module.type == 35) && module.modules?.length > 0) {
      //查询记录，关联级联或者子表单
      if ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1) {
        isDisplayField.push(module);
      }
    }
  });
  return isDisplayField;
};
// 点击--关联工商信息
const correlation = () => {
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'customerName') {
            if (list.fieldValue?.trim()) {
              informationRef.value.correlationOpen(list.fieldValue);
            } else {
              Message.warning('请输入客户名称');
            }
          }
        }
      });
    }
  });
};
const isShowGroupName = (group) => {
  let showGroup = true;
  if (!props.isAssociated) {
    //非关联记录
    if (props.getEntityObj?.associateKey) {
      //详情关联表格--新增来源
      showGroup = group?.filter((g) => g?.value != props.getEntityObj?.associateKey)?.length > 0;
    }
  } else {
    //记录来源
    if (props.modulesItem?.type == 30) {
      //关联记录-把关联记录过滤
      showGroup = group?.filter((g) => g?.type != 30)?.length > 0;
    }
  }

  return showGroup;
  //   return !props.isAssociated || group?.filter((g) => g?.type != 30)?.length > 0;
};
// 是否隐藏 关数据来源与 来源数据名称
const getFollowIsHide = (modulesItem) => {
  if ((modulesItem.value === 'entityType' || modulesItem.value === 'businessId') && props.followObj.isSourceDetailStatus) {
    return false;
  } else {
    return true;
  }
};

// 商机有关的变量
const nameList = ref({
  customerName: null,
  fundName: null
});
// 更新子表单数据
const updateSubRecord = () => {
  const getSubFormKeys = Object.keys(updateSubFormKeys.value);
  if (getSubFormKeys?.length > 0) {
    data.form.formData?.forEach((item) => {
      item.modules?.forEach((list) => {
        if (list.type == 35 && list?.modules?.length && getSubFormKeys.includes(list.setting.fieldKey)) {
          const getRecord = updateSubFormKeys.value[list.setting.fieldKey];
          if (getRecord?.length) {
            detailModuleList.value[list.id] = setEditFormTable(getRecord);
          }
        }
      });
    });
  }
};
// 调用默认值
const getDefaultValues = async (fieldKey = undefined) => {
  data.submitDisabled = true;
  //触发了默认值规则
  const getParames = {
    entity: props.entity,
    formData: data.form.formData,
    changeFieldKey: fieldKey,
    init: false
  };
  try {
    await getNewDefVal(getParames, 1);
    updateSubRecord(); //更新子表单
  } catch (error) {
    console.error('获取新默认值时出错:', error);
  } finally {
    data.submitDisabled = false;
  }
};
//子组件回调
const updateModulesItem = async (parentIndex, index, getFormatData, modulesItem) => {
  if (getFormatData) {
    data.form.formData = Object.assign(data.form.formData, getFormatData);
  } else {
    data.form.formData[parentIndex].modules[index] = modulesItem;
  }
  if (props.entity == 3 && modulesItem?.setting?.fieldKey == 'customerId') {
    //商机特殊处理
    nameList.value.customerName = modulesItem?.customValue?.label;
    hyFormatName();
    if (userInfo?.orgId === 3) {
      //商机名称 只针对租户3生效
      data.form.formData?.forEach((item) => {
        if (item?.modules) {
          item?.modules?.forEach(async (list) => {
            if (list.type == 20) {
              if (list?.setting.fieldKey === 'opportunityName' && nameList.value.customerName) {
                list.fieldValue = nameList.value.customerName + ' ' + dayjs(new Date()).format('YYYY-MM-DD');
              }
            }
          });
        }
      });
    }

    if (userInfo?.orgId === bingOrgId) {
      // 调用接口
      await getCustomer(modulesItem?.customValue?.value);
    }
  }
  if ([6, 18, 22, 12, 25, 26].includes(parseInt(modulesItem?.setting?.fieldType))) {
    //人员或部门或查找单选多选附件和富文本
    editAddForm.value?.clearValidate?.([`formData.${parentIndex}.modules.${index}.fieldValue`]);
  }
  if (props?.fromCopy || props.copy == 1 || (props.type == 30 && !props.editRecord?.length)) {
    //新建和复制数据时触发默认值规则
    if (defaultFields.value?.includes(modulesItem?.changeFieldKey)) {
      getDefaultValues(modulesItem?.changeFieldKey);
    }
    if (defaultFields.value?.includes(modulesItem?.setting?.fieldKey)) {
      getDefaultValues(modulesItem?.setting?.fieldKey);
    }
  }
};
// 校验公司名称是否重复
const companyInput = (modulesItem) => {
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'companyName', props.type);
};
// 对商机名称重复校验
const changeOpportunityName = (modulesItem) => {
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'opportunityName', props.type);
};
// 客户名称改变时删除天眼查工商信息
const customerInput = (modulesItem) => {
  data.qccId = '';
  data.qccInfo = null;
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'qccId') {
            list.fieldValue = ''; //工商id；
          }
        }
      });
    }
  });
  // 校验客户名称
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'customerName', props.type);
};
/** 迁移工具表单校验 */
const checkFormData = async () => {
  const formData = data.form.formData
    ?.flatMap((item) => item.modules)
    ?.reduce((obj, item) => {
      obj[item.value] = item.fieldValue;
      return obj;
    }, {});
  try {
    const json = await migrationToolsService.validateTenantAndUser({
      tenantId: formData[fieldMappings.tenantId],
      userId: formData[fieldMappings.userId],
      appId: formData[fieldMappings.appId],
      appSecret: formData[fieldMappings.appSecret],
      sessionId: formData[fieldMappings.sessionId],
      isStop: formData[fieldMappings.isStop] === fieldMappings.stoped ? true : false
    });
    if (json.result?.result) {
      return true;
    } else {
      Message.error(json.result?.msg || t('数据获取失败'));
      return false;
    }
  } catch (e) {
    return false;
  }
};
// 必填校验和数量限制校验
const validateFormItems = () => {
  const inputList = [0, 1, 7, 11, 13, 16, 23, 26]; // 请输入的字段
  // 遍历表单数据
  const getFormData = data.form.formData;
  for (const formItem of getFormData || []) {
    if (!formItem?.modules) continue;

    // 遍历模块
    for (const module of formItem.modules) {
      // 必填校验
      const isRequired = ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1 || module.display === 0) && (module.conditionsIsRequired === 1 || module.isRequired === 1);
      //富文本必填校验
      if (module?.type == 20 && module?.setting?.fieldType == 26 && isRequired && (module?.fieldValue == '<p><br></p>' || module?.fieldValue == '')) {
        Message.warning(t('请输入') + module?.setting?.fieldName);
        return {
          hasEmptyRequiredTable: true,
          hasOverTable: false,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }
      //  关联记录，子表单
      if (module?.type == 30 || module?.type == 35) {
        const data = detailModuleList.value?.[module.id];
        if (isRequired && (!data || data.length === 0)) {
          const requiredErrorMessage = module?.label ? `请至少添加一条【${module?.label}】数据！` : module.type === 35 ? '请至少添加一条子表单数据' : '请至少添加一条明细数据！';
          Message.warning(requiredErrorMessage);
          return {
            hasEmptyRequiredTable: true,
            hasOverTable: false,
            hasSubFormEmptyError: false,
            hasLinkError: false
          };
        }

        // 数量限制校验
        if (module.type == 35 && data && data.length > 300) {
          Message.warning('子表单数据最多添加300行！');
          return {
            hasEmptyRequiredTable: false,
            hasOverTable: true,
            hasSubFormEmptyError: false,
            hasLinkError: false
          };
        }

        //只有子表单走此逻辑 关联对象表格的必填校验在弹窗点击确定的时候校验
        if (module?.type == 35) {
          // 校验子表单超链接格式(二维数组)
          for (const list of data || []) {
            for (const item of list || []) {
              const _fieldkey = item?.setting?.fieldKey;
              const itemModule = module?.modules?.find((el) => el?.setting?.fieldKey == _fieldkey);
              if (itemModule?.setting?.isRequired && (item.fieldValue === '' || item.fieldValue === null || item.fieldValue === undefined || (Array.isArray(item.fieldValue) && item.fieldValue?.length === 0))) {
                const waringMsg = inputList.includes(item?.setting?.fieldType) ? '请输入' + item?.setting?.fieldName : '请选择' + item?.setting?.fieldName;
                Message.warning(waringMsg);
                return {
                  hasEmptyRequiredTable: false,
                  hasOverTable: false,
                  hasSubFormEmptyError: true,
                  hasLinkError: false
                };
              }

              if (item?.setting?.fieldType === 11 && item?.fieldValue && !tools.checkLink(item.fieldValue)) {
                const linkErrorMessage = '格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!';
                Message.warning(linkErrorMessage);
                return {
                  hasEmptyRequiredTable: false,
                  hasOverTable: false,
                  hasSubFormEmptyError: false,
                  hasLinkError: true
                };
              }
            }
          }
        }
      }
    }
  }

  // 如果所有检查都通过，返回没有错误的结果
  return {
    hasEmptyRequiredTable: false,
    hasOverTable: false,
    hasSubFormEmptyError: false,
    hasLinkError: false
  };
};
const editAddForm = ref();
const submit = (type) => {
  data.isApproveSave = type === 'approve';
  data.isSplit = false;
  editAddForm.value.handleSubmit();
};
const splitOrderSubmit = () => {
  data.isApproveSave = false;
  data.isSplit = true;
  editAddForm.value.handleSubmit();
};
const handleSubmit = async ({ values, errors }) => {
  console.log('handleSubmit', errors, values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    const errorMsg = Object.values(errors)?.[0]?.message;
    if (errorMsg) Message.error(errorMsg);
    editAddForm?.value.setFields(errorArray);
    return;
  }
  //关联工商信息
  const getQccId = data.form.formData?.flatMap((item) => item?.modules).find((v) => v?.setting?.fieldKey === 'qccId');

  //客户--对工商关联信息校验
  if (props.entity == 2) {
    if (getQccId && !data.qccId) {
      // 设置了条件显示
      if (((getQccId?.display == 2 && getQccId?.conditionsDisplay == 1) || getQccId?.display == 1) && (getQccId?.conditionsIsRequired == 1 || getQccId?.isRequired == 1)) {
        //没有关联工商信息
        return false;
      }
    }
  }
  //文件未上传完给提示
  const incompleteFileList = [];
  let isTableLengthError = false;
  const requiredTables = [];
  const _requiredFields = [];
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules?.forEach((list) => {
        if (list.type == 20 && list?.setting?.fieldType === 18) {
          if (list.fieldValue && list.filesList && list.fieldValue.length != list.filesList.length) {
            incompleteFileList.push(list.fieldValue);
          }
        }
        if (list.type == 30) {
          //关联对象表格数据不能超过100条
          const _moduleTableData = detailModuleList.value?.[list.id] || [];
          const newDataLength = _moduleTableData?.filter((v) => !v?.[0]?.detailId)?.length;
          if (newDataLength > 100) {
            isTableLengthError = true;
          }
          _moduleTableData?.forEach((mtd, index) => {
            mtd?.forEach((mtdf) => {
              if (mtdf?.setting?.fieldType !== 27) {
                // 非子表单校验
                if (isRequiredField(mtdf?.setting?.fieldKey, mtdf?.PERMISSION, mtdf?.setting?.isRequired) && isEmptyFieldValue(mtdf?.fieldValue)) {
                  _requiredFields.push(`${list?.id}__${index}__${mtdf?.setting?.fieldKey}`);
                  if (!requiredTables?.includes(list?.label)) {
                    //只有首次label为空才添加，否则不做添加
                    if (list?.label != '' || requiredTables?.length == 0) {
                      requiredTables.push(list?.label || t('关联记录'));
                    }
                  }
                }
              } else {
                // 子表单校验

                mtdf.modules.forEach((subModule, subIndex) => {
                  subModule.forEach((vModule) => {
                    if (isRequiredField(mtdf?.setting?.fieldKey + '.' + vModule?.setting?.fieldKey, mtdf?.PERMISSION, vModule?.setting?.isRequired) && isEmptyFieldValue(vModule?.fieldValue)) {
                      _requiredFields.push(`${list?.id}__${index}__${subIndex}__${vModule?.setting?.fieldKey}`);
                      if (!requiredTables?.includes(list?.label)) {
                        //只有首次label为空才添加，否则不做添加
                        if (list?.label != '' || requiredTables?.length == 0) {
                          requiredTables.push(list?.label || t('关联记录'));
                        }
                      }
                    }
                  });
                });
              }
            });
          });
        }
      });
    }
  });

  if (isTableLengthError) {
    Message.warning(t('关联记录单次新增数据条数最多100条！'));
    return;
  }
  formTableStore.setTableRequiredErrorData(_requiredFields);
  if (requiredTables?.length) {
    Message.warning(`请填写${requiredTables.join(',')}必填项`);
    return;
  }

  if (incompleteFileList && incompleteFileList.length) {
    Message.warning(t('文件未上传完成,请稍后提交！'));
    return;
  }
  //对币种校验
  if (detailModuleList.value && Object.keys(detailModuleList.value).length > 0) {
    const currencyType = [];
    for (const key in detailModuleList.value) {
      detailModuleList.value?.[key]?.map((list) => {
        list?.map((item) => {
          if (item?.setting?.fieldKey == 'currency' || item?.setting?.fieldKey == 'currencyType') {
            // 只能选择一种币种(商机产品的币种是：currency，其他对象产品的是：currencyType)
            currencyType.push(item.fieldValue);
          }
        });
      });
    }

    const formatArr = Array.from(new Set(currencyType));
    if (formatArr?.length > 1) {
      //有重复数据
      Message.error(t('tips.moreCurrency'));
      return;
    }
  }
  // 调用验证函数
  const validationResult = validateFormItems();

  if (validationResult.hasEmptyRequiredTable || validationResult.hasOverTable || validationResult.hasSubFormEmptyError || validationResult.hasLinkError) {
    // 如果有必填项未填写或超过数量限制，则不再继续后续操作
    return;
  }

  /******************** 迁移工具 start ***********************/
  // TAG: 迁移工具
  if (userInfo?.orgId == config.migrationOrgId && [config.migrationToolsEntity, config.migrationToolsV2Entity].includes(props.entity)) {
    const result = await checkFormData();
    if (!result) {
      return;
    }
  }

  /******************** 迁移工具 end ***********************/
  // setLoading(true);
  emits('cb', {
    type: 'submit',
    isApprove: data.isApproveSave,
    isSplit: data.isSplit,
    formData: cloneDeep(data.form.formData),
    detailModuleList: cloneDeep(detailModuleList.value),
    setAssociatedFeildData: cloneDeep(setAssociatedFeildData.value)
  });
};
const cancelForm = () => {
  emits('cb', {
    type: 'cancel'
  });
  isFullScreen.value = false;
};
//展示关联的工商信息
const businessShow = () => {
  if (data.qccId) {
    businessMessageRef.value?.messageShow(data.id, data.qccInfo);
  }
};
// 客户关联工商信息回调
const getSelectCustomer = (qccItem) => {
  data.qccId = qccItem.id; //工商id；
  data.qccInfo = qccItem;
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'qccId') {
            list.fieldValue = qccItem.id; //工商id；
          }
          if (list?.setting.fieldKey === 'customerName') {
            list.fieldValue = qccItem.name; //工商信息名称
          }
        }
      });
    }
  });
};
//车队长对商机名称特殊处理
const hyFormatName = () => {
  if (userInfo.orgId == huaYingOrdId) {
    data.form.formData?.map((dfc) => {
      dfc?.modules?.map((dfcm) => {
        if (dfcm.value == 'opportunityName' && nameList.value?.customerName && nameList.value?.fundName) {
          dfcm.fieldValue = `${nameList.value.customerName}-${nameList.value.fundName}`;
        }
      });
    });
  }
};
//车队长特殊处理
const fundChange = (v, e) => {
  nameList.value.fundName = e?.[0]?.label;
  hyFormatName();
};
// 根据客户ID获取该客户下数据
const getCustomer = async (id) => {
  try {
    const json = await clientService.getCustomer({ id });
    if (!json.error) {
      const res = json.result;
      const fieldKeyMapping = {
        input_eEF5aY: 'input_QH248P',
        cascade_AtrmjR: 'cascade_Ei8fCm',
        input_6ta7Ne: 'input_iAWnWZ',
        input_7h7GZQ: 'input_K3nsDW',
        input_6M4G3m: 'input_p36wB5',
        input_KQhDsa: 'input_4wshhc',
        input_jZsBhD: 'input_5DcwpM',
        select_single_GFCcEN: 'select_single_zJwG8e'
      };
      data.form.formData?.forEach((item, parentIndex) => {
        item.modules?.forEach((list, index) => {
          if (list.type === '20' && fieldKeyMapping[list.value]) {
            const fv = res?.find((v) => v.fieldKey === fieldKeyMapping[list.value])?.fieldValue;
            if (fv && fv !== '') {
              if (fieldKeyMapping[list.value] === 'cascade_Ei8fCm') {
                list.fieldValue = fv?.split('/');
              } else {
                list.fieldValue = fv;
              }
            } else {
              list.fieldValue = null;
            }
            if (list.fieldValue && list.fieldValue != '') {
              editAddForm.value?.clearValidate([`formData.${parentIndex}.modules.${index}.fieldValue`]);
            }
          }
        });
      });
    } else {
      Message.error(json.error?.msg || t('数据获取失败'));
    }
  } catch (e) {
    Message.error(e.message || e.statusText || t('数据获取失败'));
  }
};

defineExpose({ initForm, submit });
</script>

<style scoped lang="less">
@import './fh-form-content.less';
</style>
